import { credentialsFor } from "../../../../common/utils.es6";

// Library files live on another origin (cloud / asset gateway), where the
// browser ignores <a download> and window.open just navigates to the file.
// Fetch it as a blob and save from a same-origin object URL instead, so the
// click downloads in place. Falls back to opening the file only if the fetch
// itself fails (e.g. a host without CORS).
export const fileNameFromUrl = (url) => {
  try {
    const last = new URL(url, window.location.href).pathname.split("/").pop();
    return decodeURIComponent(last || "") || "download";
  } catch (e) {
    return "download";
  }
};

export async function downloadFile(url, name) {
  if (!url) return;
  try {
    const response = await fetch(url, credentialsFor(url));
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const blob = await response.blob();
    const objectUrl = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = objectUrl;
    const fromUrl = fileNameFromUrl(url);
    // Display names can drop the extension; borrow it from the URL then.
    const ext = /\.[a-z0-9]{1,5}$/i.exec(fromUrl);
    a.download = name ? (/\.[a-z0-9]{1,5}$/i.test(name) || !ext ? name : name + ext[0]) : fromUrl;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
  } catch (e) {
    console.warn("Download failed, opening the file instead:", e);
    window.open(url, "_blank");
  }
}
